import Behaviour, { mix } from '@/core/Behaviour'
import { ScreenMixin } from '@/core/modules/'
import SponSlide from 'spon-slide'
import anime from 'animejs'

export default class Slideshow extends mix(Behaviour).with(ScreenMixin) {
	currentSlide = 0

	mount = () => {
		this.slides = this.$el.querySelectorAll('[data-slide-item]')

		if (this.slides.length < 2) return

		let { options } = this.$el.dataset
		const defaultOptions = {
			selector: '[data-slide-item]',
			activeClass: 'is-current',
			previousButton: '[data-slide-prev]',
			nextButton: '[data-slide-next]',
			loop: true,
			delay: 5000,
			dots: false,
			paginationWrapper:
				'<div class="c-slideshow__dots flex absolute pin-b pin-l bg-green z-10 py-1 px-0-5"></div>',
			promiseBefore: false,
			accessibility: false
		}

		try {
			options = JSON.parse(options)
		} catch {
			options = {}
		}

		const mergedOptions = {
			...defaultOptions,
			...options
		}

		this.slide = new SponSlide(this.$el, mergedOptions)

		this.slide.init()

		const $pager = this.$el.querySelector('.js-slide-index')
		if ($pager) {
			this.slide.on('spon:change', ({ newIndex }) => {
				const updatedIndex = newIndex

				anime({
					targets: $pager,
					duration: 200,
					translateY: [0, '10px'],
					opacity: [1, 0],
					easing: 'cubicBezier(.77,0,.175,1)',
					complete: () => {
						$pager.innerHTML = newIndex < 10 ? `0${(updatedIndex + 1)}` : (updatedIndex + 1)

						anime({
							targets: $pager,
							duration: 200,
							delay: 50,
							translateY: ['-10px', 0],
							opacity: [0, 1],
							easing: 'cubicBezier(.77,0,.175,1)'
						})
					}
				})
			})
		}
	}

	animateSlideOut = props => {
		const { currentEl } = props

		return anime({
			targets: currentEl,
			opacity: [1, 0],
			easing: 'linear',
			duration: 150,
			complete: () => { }
		})
	}

	// animateSlideIn = props => {
	// 	const { nextEl, newIndex } = props
	// }

	unmount = () => {
		if (this.slide) this.slide.destroy()
		if (this.$$screen) this.$$screen.destroy()
	}
}


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
